import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import UEConfirmModal from "../crud/UEConfirmModal";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useStripe, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js"; // Import loadStripe

const SubscriptionInfoContent = (props) => {
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      comment: "",
      feedback: "other",
    },
  });

  // Define the commitment period in days
  const commitmentPeriodDays = 0;

  // Calculate relevant dates
  const subscriptionStartDate = new Date(props?.currentSubscription?.created * 1000);
  const currentDate = new Date();
  const subscriptionEndDate = new Date(props?.currentSubscription?.current_period_end * 1000);
  const cancelAtDate = props?.currentSubscription?.cancel_at
    ? new Date(props.currentSubscription.cancel_at * 1000)
    : null;

  // Calculate days since subscription start
  const daysSinceStart = Math.floor((currentDate - subscriptionStartDate) / (1000 * 60 * 60 * 24));

  // Determine if within commitment period
  const isWithinCommitmentPeriod = daysSinceStart < commitmentPeriodDays;

  // Calculate days left in commitment period
  const daysLeft = commitmentPeriodDays - daysSinceStart;

  const cancelSubscription = async (data) => {
    data.subscription_id = props?.currentSubscription?.id;
    setLoading(true);
    try {
      let result = await axios.post("/Api/entity/subscription/cancel", data);
      if (result.data?.success) {
        window.location.reload();
      } else {
        toast.error(
          "Un problème s'est produit et votre demande n'a pas pu être traitée. Merci de contacter le support pour plus d'informations",
          { duration: 6000 }
        );
      }
    } catch (error) {
      toast.error(
        "Une erreur s'est produite lors de l'annulation de l'abonnement. Veuillez réessayer plus tard.",
        { duration: 6000 }
      );
    }
    setLoading(false);
  };

  const [isCancellable, setIsCancellable] = useState(false);
  const [cancellationEligibleDate, setCancellationEligibleDate] = useState(new Date());

  useEffect(() => {
    if (props?.currentSubscription?.id) {
      checkIfCancellable(props.currentSubscription.id);
    }
  }, [props?.currentSubscription?.id]);

  const createPortalSession = async () => {
    setLoading(true);
    try {
      const response = await axios.post("/Api/create-portal-session", {
        return_url: "http://localhost:8000/home", 
      });

      if (response.data?.url) {
        // Redirect the user to the Stripe billing portal
        window.location.href = response.data.url;
      } else {
        toast.error("Failed to create billing portal session.");
      }
    } catch (error) {
      console.error("Error creating billing portal session:", error);
      toast.error("An error occurred. Please try again later.");
    }
    setLoading(false);
  };

  const checkIfCancellable = async (id) => {
    setLoading(true);
    let data = { subscription_id: id };
    try {
      let result = await axios.post("/Api/entity/subscription/isCancellable", data);
      if (result.data?.success) {
        setIsCancellable(result.data.can_be_cancelled);
        setCancellationEligibleDate(new Date(result.data.cancellation_eligibleDate));
        console.log(result.data);
      }
    } catch (error) {
      console.error("Could not check if subscription is cancellable", error);
    }

    setLoading(false);
  };

  const getSubscriptionFriendlyName = (nickname) => { // Fixed typo in function name
    let friendlyName = "top";
    if (nickname === "abo-pro") {
      friendlyName = "Pro";
    } else if (nickname === "abo-pro_2") {
      friendlyName = "Pro+";
    } else if (nickname === "abo-solaire") {
      friendlyName = "Solaire";
    } else {
      friendlyName = nickname;
    }
    return friendlyName;
  };

  return (
    <div
      className={
        "d-flex flex-column justify-content-start align-content-center align-content-md-start w-100 p-2 bg-white"
      }
    >
      <div className={"d-md-flex"}>
        <div className={"w-100 p-md-3"}>
          <h5
            className={"text-dark font-weight-bold"}
            style={{
              fontSize: "13px",
              marginBottom: "14px",
              paddingTop: "5px",
            }}
          >
            Abonnement
          </h5>
          <div className="did-floating-label-content">
            <input
              className="did-floating-input"
              type="text"
              id={"subscription_type"}
              name={"subscription_type"}
              placeholder=" "
              readOnly
              value={getSubscriptionFriendlyName(props?.currentSubscription?.plan?.nickname)}
            ></input>
            <label className="did-floating-label">Forfait</label>
          </div>
          <div className="did-floating-label-content">
            <input
              className="did-floating-input"
              type="text"
              id={"subscription_start_at"}
              name={"subscription_start_at"}
              placeholder=" "
              readOnly
              value={subscriptionStartDate.toLocaleDateString()}
            ></input>
            <label className="did-floating-label">Date début</label>
          </div>

          <div className="did-floating-label-content">
            <input
              className="did-floating-input"
              type="text"
              placeholder=" "
              readOnly
              name={"subscription_end_at"}
              id={"subscription_end_at"}
              value={subscriptionEndDate.toLocaleDateString()}
            ></input>
            <label className="did-floating-label">Fin de période de facturation en cours</label>
          </div>

          <div className="did-floating-label-content">
            <input
              className="did-floating-input"
              type="text"
              placeholder=" "
              readOnly
              name={"subscription_amount"}
              id={"subscription_amount"}
              value={
                props?.subscriptionAmount
                  ? (props.subscriptionAmount / 100.0).toFixed(2) + "€"
                  : "0.00€"
              }
            ></input>
            <label className="did-floating-label">Tarif</label>
          </div>

          
        </div>
      </div>
      <UEConfirmModal
        showButtons={false}
        isOpened={showModal}
        title={"Supprimer l'abonnement"}
        onProceed={() => {}}
        onClose={() => {
          setShowModal(false);
        }}
      >
        <h4 className={"text-center text-primary my-3"}>
          Êtes-vous sûr de vouloir supprimer votre abonnement ?
        </h4>
        <h6>
          <span className={"font-weight-bold"}>Attention,</span> en supprimant cet abonnement vous
          perdez toutes possibilité de création de documents et de consultation de données
        </h6>
        <p className={"text-center font-weight-bold my-3"}>
          <span className={"font-weight-normal"}>Validation :</span> {props?.entity?.slug}
        </p>
        <form className={"my-4"} onSubmit={handleSubmit(cancelSubscription)}>
          <div className={"form-group"}>
            <label htmlFor="entity_name" className={"ue-col-form-label "}>
              Merci de saisir le texte de validation pour confirmer :{" "}
            </label>
            <input
              type="text"
              className={"form-control ue-form-control"}
              name={"entity_name"}
              {...register("entity_name", {
                validate: (value) => value === props?.entity?.slug,
              })}
            />
            {errors?.entity_name && (
              <span className={"ue-form-error pl-4 m-2"}>
                Le champ n'est pas correctement validé !
              </span>
            )}
          </div>
          <div className={"form-group"}>
            <label htmlFor="comment" className={"ue-col-form-label "}>
              Vous pouvez commenter votre action et nous aider à améliorer notre service :{" "}
            </label>
            <textarea
              className={"form-control ue-form-control"}
              name={"comment"}
              {...register("comment")}
              rows={6}
            />
          </div>
          <div className={"d-flex justify-content-center align-items-center my-4"}>
            <button
              type="button"
              className={"btn btn-outline-primary d-inline-block mr-3"}
              onClick={() => {
                setShowModal(false);
              }}
            >
              ANNULER
            </button>
            <button type={"submit"} className={"btn btn-primary text-white"} disabled={loading}>
              {loading ? "Confirmation en cours..." : "JE CONFIRME MON DÉSABONNEMENT"}
            </button>
          </div>
        </form>
      </UEConfirmModal>
    </div>
  );
};

const SubscriptionInfo = (props) => {
  return (
  <Elements stripe={loadStripe(props.stripePubKey)}>
      <SubscriptionInfoContent {...props} />
    </Elements>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.MeReducer.id,
    username: state.MeReducer.username,
    role: state.MeReducer.role,
    isLeader: state.MeReducer.isLeader,
    uiTheme: state.AppReducer.ui_theme,
    userPrefs: state.MeReducer?.prefs,
    structureInfo: state.SubscribtionReducer.structureInfo,
    entity: state.MeReducer.entity,
    currentSubscription: state.MeReducer.currentSubscription,
    subscriptionAmount: state.MeReducer.subscriptionAmount,
    nextBillingDate: state.MeReducer.nextBillingDate,
    stripePubKey: state.StripeReducer.pubKey,
  };
};

const mapDispatchTProps = (dispatch) => {
  return {
    updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
  };
};

export default connect(mapStateToProps, mapDispatchTProps)(SubscriptionInfo);
